import type { GetB2bFullyManagedPlanContributionsOneResponse } from '@Common/types/b2b/orders';

export const b2bFullyManagedPlanContributionsTranslations = {
  status: {
    pending: 'Pending',
    paid: 'Paid',
    shares_canceled: 'Cancelled',
    funding_failed: 'Funding failed',
  } satisfies Record<GetB2bFullyManagedPlanContributionsOneResponse['status'], string>,
  type: {
    campaign_allocation: 'Campaign allocation',
    cross_plan_arbitrage: 'Cross plan arbitrage',
    employer_matching_contribution: 'Employer matching contribution',
    voluntary_deposit: 'Voluntary deposits',
  } satisfies Record<GetB2bFullyManagedPlanContributionsOneResponse['contribution_type'], string>,
};
